import React from "react";
import { useNavigate } from "react-router-dom";
import Transition from "../../components/Transition";
import { AnimatePresence } from "framer-motion";

export default function Error(props) {
    const navigate = useNavigate();
    return (
        <AnimatePresence mode="wait">
            <Transition key={props.message}>
                <div className="container h-100">
                    <div className="row justify-content-center h-100 align-items-center">
                        <div className="col-md-5">
                            <div className="form-input-content text-center error-page">
                                <h1 className="error-text fw-bold">{props.code}</h1>
                                <h4><i className="fa fa-times-circle text-danger"></i> {props.message}</h4>
                                <p>Your Request resulted in an error</p>
                                <div>
                                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                                        Go Back
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Transition>
        </AnimatePresence>

    );
}